
// Set some constants to refer to elements on the page
const biro_page_contents_expander           = document.querySelector( '#page-contents-nav-expander' );
const biro_page_contents_expander_header    = document.querySelector( '#page-contents-nav-expander-header' );
const biro_page_contents_toggle             = document.querySelector( '#page-contents-toggle' );
const biro_page_contents_expander_list_wrap = document.querySelector( '#page-contents-nav-expander-list-wrap' );
const biro_page_contents_list_in_page       = document.querySelector( '#page-contents-list-in-page' );
const biro_mobile_header                    = document.querySelector( '#header-mobile' );
